import { rgba } from 'polished';
import { focusOutline, index, Options } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import styled, { keyframes } from 'styled-components';

const inAnimation = keyframes`
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};

  position: fixed;
  bottom: ${({ theme }) => theme.spacing(5)};
  right: ${({ theme }) => theme.spacing(5)};
  z-index: ${index(Options.BOTTOM_RIGHT_MESSAGE)};

  width: 31.2rem;
  max-width: calc(100vw - ${({ theme }) => theme.spacing(8)});
  padding: ${({ theme }) => theme.spacing(4)};

  border-radius: ${({ theme }) => theme.spacing(4)};
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  background: ${({ theme }) => rgba(theme.palette.grey[100], 0.85)};
  backdrop-filter: blur(24px);
  box-shadow: ${({ theme }) => theme.shadowBox.menu};

  transform: ${({ theme }) => `translateY(${theme.spacing(12)})`};
  opacity: 0;

  animation: ${inAnimation} 200ms 400ms linear forwards;
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing(2)};
  right: ${({ theme }) => theme.spacing(2)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.h5)};
  padding-right: ${({ theme }) => theme.spacing(6)};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const OptionButton = styled.button`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};

  width: 100%;
  padding: ${({ theme }) => theme.spacing(3)};

  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => theme.spacing(2.5)};
  background: ${({ theme }) => theme.palette.background.default};
  cursor: pointer;

  color: ${({ theme }) => theme.palette.text.primary};
  text-align: center;

  &:hover {
    background: ${({ theme }) => theme.palette.grey[100]};
    border-color: ${({ theme }) => theme.palette.primary.main};
  }

  &:focus-visible {
    ${focusOutline};
  }
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const TextAreaWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => theme.spacing(2)};
  background: ${({ theme }) => theme.palette.background.default};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: stretch;

  button {
    width: 100%;
  }
`;

export const ThankYou = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle1)};
  color: ${({ theme }) => theme.palette.text.primary};
`;
